
import Vue from "vue";
import CrmHistory from "@/models/crm/crm-history";

export default Vue.extend({
	data() {
		return {};
	},
	props: {
		event: {
			required: true,
			type: Object as () => CrmHistory
		},
	},
	computed: {
		date(): string{
			let date = (this.event.ComputedProps as any).timestamp;
			let day = String(date.getDate()).padStart(2, "0");
			let month = String(date.getMonth() + 1).padStart(2, "0");
			let year = date.getFullYear();
			return `${day}/${month}/${year}`;
		},
		time(): string{
			let date = (this.event.ComputedProps as any).timestamp;
			let hours = String(date.getHours()).padStart(2, "0");
			let minutes = String(date.getMinutes()).padStart(2, "0");
			return `${hours}:${minutes}`;
		},
		title(): string{
			return this.$ct("event-actions.appointment",{date: this.date,time: this.time}).toString();
		}
	},
	components: {

	},
	i18nEx: {
		componentPrefix: "components.crm"
	}
});
